import { faEdit, faEllipsisV, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CoreCell, flexRender } from '@tanstack/react-table'

import Button from '@/components/Button/Button'
import { TableActionCell } from '@/components/Table/styles'
import { RowProps } from '@/components/Table/types'
import { ItemType } from '@/types'

export const TableRowContent = ({
	alwaysShowRowActions,
	hasLeftAction,
	hasLastRowEdit,
	hasRightAction,
	isEditMode,
	isLastRow,
	isRowEditDisabled,
	onEdit,
	onDelete,
	row,
	dragRef,
}: RowProps<ItemType>) => {
	const editDisabled = isRowEditDisabled?.(row.original) ?? false

	const editHandler = () => {
		if (editDisabled) return
		return onEdit && onEdit(row.original)
	}

	const deleteHandler = () => {
		return onDelete && onDelete(row.original)
	}

	return (
		<>
			{hasLeftAction && (
				<TableActionCell
					$alwaysShowRowActions={alwaysShowRowActions}
					$hasLastRowEdit={hasLastRowEdit}
					$isEditMode={isEditMode}
					$isLastRow={isLastRow}
					ref={dragRef}
				>
					<div className="flex w-10 min-w-10 items-center justify-center">
						<Button size="sm" schema="transparent">
							<FontAwesomeIcon icon={faEllipsisV} color="grey" />
						</Button>
					</div>
				</TableActionCell>
			)}

			{row.getVisibleCells().map((cell: CoreCell<any, any>) => {
				return (
					<td key={cell.id}>
						{flexRender(cell.column.columnDef.cell, cell.getContext())}
					</td>
				)
			})}

			{hasRightAction && (
				<TableActionCell
					$alwaysShowRowActions={alwaysShowRowActions}
					$hasLastRowEdit={hasLastRowEdit}
					$isEditMode={isEditMode}
					$isLastRow={isLastRow}
				>
					<div className="flex min-w-10 items-center justify-center">
						{hasLastRowEdit && (
							<Button
								disabled={editDisabled}
								size="sm"
								schema="transparent"
								onClick={editHandler}
							>
								<FontAwesomeIcon icon={faEdit} />
							</Button>
						)}

						<Button size="sm" schema="transparent" onClick={deleteHandler}>
							<FontAwesomeIcon icon={faTimes} color="red" />
						</Button>
					</div>
				</TableActionCell>
			)}
		</>
	)
}
